<template>
  <div class="module--dashboard_dash_block">
    <div class="title" v-if="title">{{ title }}</div>
    <slot name="head"></slot>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"]
}
</script>

<style lang="scss">
.module--dashboard_dash_block{
  border: 1px solid #e3e3e3;
  // background: #f5f5f5;
  border-radius: 5px;
  box-shadow: 0px 1px 5px #ddd;
  display: flex;
  flex-direction: column;
  background: white;
  & > .title{
    margin-bottom: 10px;
    font-size: small;
    background: #414e75;
    color: white;
    padding: 5px 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  & > .content{
    padding: 15px;
    flex-grow: 1;
  }
}
</style>